import { useRef } from 'react';
import { useUnit } from 'effector-react';
import { $account } from '@features/common';
import { ContactCallsBadge } from './badge';
import { ErrorSnackbar } from './error-snackbar';
import { ContactCallsPopper } from './popper';

export const ContactCalls = () => {
  const [account] = useUnit([$account]);
  const badgeRef = useRef<HTMLButtonElement | null>(null);

  if (!account.contact_center_name) return null;

  return (
    <>
      <ErrorSnackbar />

      <ContactCallsBadge badgeRef={badgeRef} />

      <ContactCallsPopper badgeRef={badgeRef} />
    </>
  );
};
